import React from "react";
import { NavLink, Outlet, Navigate, useNavigate } from "react-router-dom";
import { useApp } from "@/context/AppContext";
import { LayoutDashboard, Palette, ListTree, ClipboardCheck, LogOut, ArrowLeft } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function AdminLayout() {
  const { adminLoggedIn, adminLogout } = useApp();
  const navigate = useNavigate();

  if (!adminLoggedIn) return <Navigate to="/admin/login" replace />;

  const navItem = ({ isActive }) =>
    `flex items-center gap-2 px-3 py-2 rounded-md text-sm transition-colors ${isActive ? "text-white" : ""}`;

  return (
    <div className="max-w-7xl mx-auto px-4 md:px-6 py-6 fade-in">
      <div className="flex flex-col md:flex-row gap-6">
        <aside className="md:w-60 shrink-0">
          <div className="amd-card rounded-lg p-3 md:sticky md:top-28">
            <div className="px-2 py-2 mb-2">
              <div className="text-xs uppercase tracking-wider font-bold" style={{ color: "var(--amd-primary)" }}>Administrare</div>
              <div className="font-black text-white">amd64.ro</div>
            </div>
            <nav className="grid gap-1">
              <NavLink to="/admin" end className={navItem} style={({ isActive }) => isActive ? { background: "var(--amd-primary)" } : { color: "var(--amd-text-muted)" }}><LayoutDashboard className="w-4 h-4" /> Dashboard</NavLink>
              <NavLink to="/admin/theme" className={navItem} style={({ isActive }) => isActive ? { background: "var(--amd-primary)" } : { color: "var(--amd-text-muted)" }}><Palette className="w-4 h-4" /> Teme & Stocare</NavLink>
              <NavLink to="/admin/categories" className={navItem} style={({ isActive }) => isActive ? { background: "var(--amd-primary)" } : { color: "var(--amd-text-muted)" }}><ListTree className="w-4 h-4" /> Categorii</NavLink>
              <NavLink to="/admin/moderation" className={navItem} style={({ isActive }) => isActive ? { background: "var(--amd-primary)" } : { color: "var(--amd-text-muted)" }}><ClipboardCheck className="w-4 h-4" /> Moderare anunțuri</NavLink>
            </nav>
            <div className="h-px my-3" style={{ background: "var(--amd-border)" }} />
            <div className="grid gap-2">
              <Button onClick={() => navigate("/")} variant="outline" className="justify-start border-white/20 text-white hover:bg-white/5 h-9"><ArrowLeft className="w-4 h-4 mr-2" /> Vezi site-ul</Button>
              <Button onClick={() => { adminLogout(); navigate("/"); }} variant="outline" className="justify-start border-white/20 text-white hover:bg-white/5 h-9"><LogOut className="w-4 h-4 mr-2" /> Deconectare</Button>
            </div>
          </div>
        </aside>
        <main className="flex-1 min-w-0"><Outlet /></main>
      </div>
    </div>
  );
}
